module.exports = __webpack_public_path__ + "img/cooperative1_logo3.dd884ec4.jpg";